import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  timsCardHeader: {
    id: 'timsCardHeader',
    defaultMessage: 'Tim Card',
    description: 'Tab header text that shows the users Tim Hortons card',
  },

  timsRewardsHeader: {
    id: 'timsRewardsHeader',
    defaultMessage: 'Tims Rewards',
    description: 'Tab header text that shows the users their Tim Hortons rewards points',
  },

  loyaltyUnavailableInRegionOops: {
    id: 'loyaltyUnavailableInRegionOops',
    defaultMessage: 'Oops!',
    description: 'Sorry headline for when loyalty is not available in users region',
  },

  differentRegion: {
    id: 'differentRegion',
    defaultMessage: 'a different region',
    description:
      "If we fail to get the user's region from loyalty query and local storage, we will show this string instead of undefined",
  },

  /**
   * ========================= tim-card.tsx =========================
   */
  reloadYourCard: {
    id: 'reloadYourCard',
    defaultMessage: 'Reload Your Card',
    description: 'Title text for the modal that asks the users it load their tim card again',
  },

  currencyInfo: {
    id: 'currencyInfo',
    defaultMessage:
      'The format of your currency is determined by your locale. Change your locale to update your format.',
    description:
      'Tooltip text that says that if you change the locale it will change how the currency is outputted',
  },

  timCard: {
    id: 'timCard',
    defaultMessage: 'Tim Card',
    description: 'Alternative text for teh tim card demo image',
  },

  yourTimCardBalance: {
    id: 'yourTimCardBalance',
    defaultMessage: 'Your Tim Card Balance',
    description: 'Header text that for the users tim card balance',
  },

  transferBalanceFromAnotherTimCard: {
    id: 'transferBalanceFromAnotherTimCard',
    defaultMessage: 'Transfer balance from another Tim Card',
    description: 'Button that asks if the user wants to move money from one card to another',
  },

  emptyStateTimCTACopy: {
    id: 'emptyStateTimCTACopy',
    defaultMessage: 'Get Started',
    description: 'Button that asks the user if they want to get started',
  },

  emptyStateTimCardCopy: {
    id: 'emptyStateTimCardCopy',
    defaultMessage:
      'Scan to pay will become available after your first digital purchase, or by transferring in a Tim Card® balance',
    description: 'Header text tells the user what they have to do for scan to pay to work',
  },

  close: {
    id: 'close',
    defaultMessage: 'Close',
    description: 'This button will close the modal',
  },

  putThisCodeUnderTheScanner: {
    id: 'putThisCodeUnderTheScanner',
    defaultMessage: 'Put this code under the scanner',
    description: 'Heading text that is asking the user to put the discount code under the scanner',
  },

  scanToPayWithYourTimCard: {
    id: 'scanToPayWithYourTimCard',
    defaultMessage: 'Scan to Pay',
    description: 'Header text that instructs the user to scan the card on their phone',
  },

  unableToLoadTimCardNoInternet: {
    id: 'unableToLoadTimCardNoInternet',
    defaultMessage: 'Unable to load TimCard, please connect to internet.',
    description: 'Error that tells the user the card cannot be loaded due to poor internet',
  },

  reloadCardWithAmount: {
    id: 'reloadCardWithAmount',
    defaultMessage: 'Reload {amount}',
    description: 'Button to reload card with {dollar amount}',
  },
});
